module.exports = __webpack_public_path__ + "img/handler.307af352.svg";